export default __webpack_public_path__ + "static/media/melina-servant.2603d527.jpg";